import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiInstagram, FiMail, FiMapPin, FiSend } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f0507] border-t border-gray-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand & Mission */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-red-600 rounded-xl flex items-center justify-center shadow-lg shadow-red-900/20">
                <span className="text-white font-bold text-lg">PC</span>
              </div>
              <span className="text-white text-2xl font-bold tracking-tight">PlayConnect</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              The ultimate sports matchmaking platform for Dhaka. We're on a mission to bring athletes together, one match at a time.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://facebook.com" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-red-600 hover:text-white transition-all duration-300">
                <FiFacebook size={18} />
              </a>
              <a href="https://twitter.com" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-red-600 hover:text-white transition-all duration-300">
                <FiTwitter size={18} />
              </a>
              <a href="https://instagram.com" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-red-600 hover:text-white transition-all duration-300">
                <FiInstagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Navigation */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Platform</h4>
            <ul className="space-y-4">
              <li><Link to="/discover" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Find Matches</Link></li>
              <li><Link to="/create-match" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Organize a Game</Link></li>
              <li><Link to="/dashboard" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Player Dashboard</Link></li>
              <li><Link to="/my-matches" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Tournament History</Link></li>
            </ul>
          </div>

          {/* Support & Contact */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Support</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 group">
                <FiMail className="text-red-500 mt-1 group-hover:scale-110 transition-transform" />
                <a href="mailto:support@playconnectbd.me" className="text-gray-400 hover:text-white transition-colors text-sm">support@playconnectbd.me</a>
              </li>
              <li className="flex items-start space-x-3">
                <FiMapPin className="text-red-500 mt-1" />
                <span className="text-gray-400 text-sm">Gulshan-2, Dhaka, Bangladesh</span>
              </li>
              <li><Link to="/faq" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Help Center</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-red-500 transition-colors text-sm">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Stay Updated</h4>
            <p className="text-gray-400 text-sm mb-4">Get the latest match alerts and community news.</p>
            <form className="relative group" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Email address"
                className="w-full bg-gray-900/50 border border-gray-800 text-white text-sm rounded-xl px-4 py-3 outline-none focus:border-red-600 transition-all"
              />
              <button 
                type="submit"
                className="absolute right-2 top-1.5 p-1.5 bg-red-600 rounded-lg text-white hover:bg-red-700 transition-colors"
              >
                <FiSend size={16} />
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-xs tracking-wide">
            © {currentYear} PLAYCONNECT. BUILT FOR DHAKA ATHLETES.
          </p>
          <div className="flex space-x-8 text-xs text-gray-500">
            <Link to="/terms" className="hover:text-white transition-colors">TERMS OF SERVICE</Link>
            <Link to="/guidelines" className="hover:text-white transition-colors">COMMUNITY GUIDELINES</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
